import React from 'react';
import styled from 'styled-components';
import footerLogo from '../../img/Footer/footerLogo.png';
import { SocialMediaSectionFooter } from '../../components/MainSection/components/MainSectionBody/components/SocialMediaSection/SocialMediaSection';
import { Paragraph } from '../Paragraph';

const FooterWrapper = styled.section`
  width: 100%;
  border-top: 2px solid #C49A6C;
  background: white;
  margin-top: 62px;
  padding: 22px;
  box-sizing: border-box;
`;

const FooterLogoWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const FooterLogo = styled.div`
  height: 87px;
  width: 230px;
  background: url(${footerLogo});
  background-repeat: no-repeat;
`;

const FooterDownBody = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 23px;
`;

const FooterCopyrights = styled(Paragraph)`
  font-size: 14px;
`;

const FooterLink = styled.a`
  font-size: 14px;
  margin: 1em 0;
  color: #000;
  margin-left: 10px;
  text-decoration: none;
  font-family: 'Roboto';
  line-height: 150.2%;
`;

const LinksWrapper = styled.div`
  display: flex;
`;

export const Footer = () => (
  <FooterWrapper>
    <FooterLogoWrapper>
      <FooterLogo />
    </FooterLogoWrapper>
    <SocialMediaSectionFooter />
    <FooterDownBody>
      <FooterCopyrights>
        © Copyrights 2020 Gospodarstwo ogrodnicze owocowo.com.pl
      </FooterCopyrights>
      <LinksWrapper>
        <FooterLink href="https://www.sklep.owocowo.com.pl/">
          SKLEP
        </FooterLink>
        <FooterLink>
          |
        </FooterLink>
        <FooterLink href="https://www.sklep.owocowo.com.pl/">
          KONTAKT
        </FooterLink>
      </LinksWrapper>
    </FooterDownBody>
  </FooterWrapper>
);
